import React from 'react'
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'

import { availableLanguages } from './../assets/translations/availableLanguages'

export default class LanguageSelectorFormControl extends React.Component {
  render() {
    const {
      showOnlyAdminLanguages,
      shouldTranslateLanguages,
      withoutFormGroup,
      label,
      defaultValue,
      onChange,
      isDisabled
    } = this.props

    const languages = showOnlyAdminLanguages
      ? availableLanguages.filter(l => l.availableInAdmin)
      : availableLanguages

    const formControlElement = (
      <FormControl
        name="language"
        componentClass="select"
        onChange={onChange.bind(this)}
        defaultValue={defaultValue}
        disabled={isDisabled}
      >
        {languages.map(l => (
          <option value={l.key} key={l.key}>
            {shouldTranslateLanguages ? i18next.t(l.translationKey) : l.name}
          </option>
        ))}
      </FormControl>
    )

    if (withoutFormGroup) {
      return formControlElement
    }

    return (
      <FormGroup controlId="language">
        <ControlLabel>{label}</ControlLabel>
        {formControlElement}
      </FormGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageSelectorFormControl.js